import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {FormGroup, Validators} from "@angular/forms";
import {DictionaryService} from "@amlCore/services";
import {IDictItemType} from "@amlCore/interfaces";
import {ClientTypeEnum} from "@amlCore/enums";
import {Unsubscribable} from "rxjs";
import {InternalService} from "../internal.service";
import {Utils} from "@amlCore/utils";
import {AlertPanelComponent, AlertPanelService, ICustomSelectMapper} from "@amlCore/components";
import {ActivatedRoute, Router} from "@angular/router";
import {DictType} from "../../../../client/models/dossier";
import {ConfirmComponent} from "@amlCore/modals";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileSaverService} from "ngx-filesaver";

@Component({
  selector: 'app-internal-address',
  templateUrl: './internalAddress.component.html'
})
export class InternalAddressComponent implements OnInit, OnDestroy {
  id: string; // id записи (если есть - форма редактирования/просмотра)
  regionMapper: ICustomSelectMapper;
  formGroupValueChanges: Unsubscribable;
  unsubList: Unsubscribable[] = [];
  countryList: Array<DictType> = [];
  regionList: Array<DictType> = [];
  @Input() submitted: boolean = false;
  @Input() formGroupApp: FormGroup;
  @Output() modelChange: any = new EventEmitter<any>();

  constructor(private dictSrv: DictionaryService) {
  }

  ngOnInit(): void {
    this.initDict(); // Подгружаем справочники
    setTimeout(() => {
      this.formGroupValueChanges = this.formGroupApp.valueChanges.subscribe(data => {
        this.modelChange.emit(data);
      });
      this.unsubList.push(this.formGroupValueChanges);
    });
    this.regionMapper = {
      toModel: this.regionMapperToModel.bind(this)
    } as ICustomSelectMapper;
  }

  /**
   * Описание преобразования объекта списка регионов для модели
   * @param origin - данные элемента списка
   * @param isDictData - если true, то origin - данные справочника
   *                          false, то origin - преобразованные данные модели (DictType)
   */
  regionMapperToModel(origin: any, isDictData: boolean): any {
    if (isDictData) {
      return {
        code: origin.code,
        name: origin.formalname + ' ' + origin.shortname
      };
    } else {
      return origin;
    }
  }

  /**
   * Заполняем адрес из фиаса
   */
  fillAddress(data) {
    if (data) {
      this.formGroupApp.patchValue({
        postIndex: data.postalcode,
        region: data.regionCode,
        area: data.area,
        city: data.city,
        locality: data.locality,
        street: data.street,
        house: data.house,
        building: data.building
      });
    }
  }

  /**
   * Инициализация справочников
   */
  private initDict(): void {
    this.dictSrv.getRemoteData("oksm").then((list) => {
      this.countryList = list;
    });
    this.dictSrv.getRemoteData("fiasregion").then((list) => {
      this.regionList = list;
    });
  }

  f(field: string) {
    return this.formGroupApp.get(field);
  }


  ngOnDestroy(): void {
    this.unsubList.forEach(sub => sub.unsubscribe());
  }
}
